/**
 * SignatureController
 */

"use strict";

/**
 * Mise à jour de la sigature
 * @param {int} bbmindex Index de l'element
 * @param {type} uniqId Identifiant de la zone msgSuccess pour recevoir
 *  le message ok
 * @param {string} nomChamp Nom du champ à mettre à jour
 */
function callSignatureUpdate(bbmindex, uniqId, nomChamp)
{
    require(
            ['jquery', "checkFeatures", 'Seed', 'Seed.Ajax', 'Seed.Tab'],
            function ($, checkFeatures, Seed) {
                var selectOutput = '#output_' + uniqId;
                var output = $(selectOutput).val();

                Seed.Ajax.Post({
                    url: "_module/signature/SignatureJqueryUpdate.php",
                    data: "output=" + output
                            + "&bbmindex=" + bbmindex
                            + "&nomChamp=" + nomChamp,
                    async: false,
                    json: false,
                    success: function (xml) {
                        var msg = "#msgSuccess_" + uniqId;
                        $(msg).css("display", "inline-block");
                        setTimeout(function () {

                            $(msg).css("display", "none");
                        }, 500);
                    }
                });
                if (checkFeatures.isSmallDevice()) {
                    Seed.Tab.Reload();
                }
            },
            function (err) {
                console.error("ERROR: ", err.requireType);
                console.error("MODULES: ", err.requireModules);
            }
    );
}

/**
 * Mise à jour du symbole décrivant l'existence ou non d'une signature
 * @param {int} bbmindex Index de l'element
 */
function signCheck(bbmindex)
{
    require(
            ['Seed', 'Seed.Ajax', 'Seed.Tab'],
            function (Seed) {
                var myFrame = Seed.Tab.GetFrame().find("#alreadyDone");
                if (myFrame.length !== 0) {
                    myFrame.toggleClass();
                    Seed.Ajax.Post({
                        url: "_module/SignCheck.php",
                        data: "bbmindex=" + bbmindex,
                        json: false,
                        async: true,
                        success: function (result) {
                            if (result === "1") {
                                myFrame.addClass("fa fa-check");
                            } else if (result === "0") {
                                myFrame.addClass("fa fa-times");
                            }
                            Seed.Tab.Reload();
                        }});
                }
            }
    );
}
/**
 * Automatic close of the modal on signature saving
 */
function closeModal()
{
    //This selector is the button to close
    setTimeout(function () {
        $('div.modal-footer button:first-child').click();
    }, 300);
}

function callSignature(message, id, bbm)
{
    require(
            ['jquery', 'bootbox', 'Seed'],
            function ($, bootbox, Seed) {
                bootbox.confirm(
                        message,
                        function (result) {
                            var aSelector = Seed.Tab.GetFrame().find('#deleteOneLink');
                            aSelector.removeClass();
                            if (result) {
                                $('.sigPad#' + id).signaturePad().clearCanvas();
                                callSignatureUpdate(
                                        bbm,
                                        'signature_' + id,
                                        'signature'
                                        );
                            }
                        }
                );
            }
    );
}

function initialize(signature, id)
{
    require(
            ["jquery", "signature-pad"],
            function () {
                var options = {
                    drawOnly: true,
                    lineTop: '180'
                };
                if (signature === "") {
                    $('.sigPad#' + id).signaturePad(options);
                } else {
                    $('.sigPad#' + id).signaturePad(options)
                            .regenerate(signature);
                }
            },
            function (err) {
                console.error("ERROR: ", err.requireType);
                console.error("MODULES: ", err.requireModules);
            }
    );
};
define("signatureController", function(){});

